import React, {Component} from 'react';
import * as apis from '../../utils/apis';
import { connect } from "react-redux";
import DataGrid, {
    Column,
    Editing,
    Popup,
    Position,
    GroupPanel,
    FilterPanel,
    FilterRow,
    ColumnChooser,
    Scrolling,
    RequiredRule,
    FormItem
} from 'devextreme-react/ui/data-grid';
import { StringLengthRule } from 'devextreme-react/validator';


const getHeight = () => {
    return (window.innerHeight - 48)
}

class WOPriorityGrid extends Component {
    state = {
        gridHeight: 0,
    };

    resize = () => {
       this.gridview.instance.option('height',getHeight());
      }
    
      componentDidMount() {
        window.addEventListener('resize', this.resize)
      }
      
      componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
      }

      setDefaultNewValues = (e) => {
        e.data.active = true; 
      }

      onEditorPreparing = (e) =>  {
      
     if(e.dataField === "numericValue") {
         e.editorName = "dxNumberBox";
     }
   }

   onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'refresh',
          onClick: this.refreshGrid 
        }
      });
    }

    refreshGrid = () => {
        this.gridview.instance.refresh(true);
    }

    render() {
        return  (
            <DataGrid 
            dataSource={apis.WOPriorityDataSource(this.props.user.access_token)}  
            noDataText="There are no workorder priorities defined."
            rowAlternationEnabled={true}  
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}  
            columnHidingEnabled={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            stateStoring={{ enabled: 'true',type: 'localStorage', storageKey: 'bookingTypes' }}
            height={getHeight}
            width="100%" ref={(gv) => {this.gridview = gv}}
            onInitNewRow={this.setDefaultNewValues} onEditorPreparing={this.onEditorPreparing} onToolbarPreparing={this.onToolbarPreparing}
         >
           <Editing
            mode={'popup'}
            allowUpdating={this.props.grants.rights.adminWOPriorities}
            allowDeleting={this.props.grants.rights.adminWOPriorities}
            allowAdding={this.props.grants.rights.adminWOPriorities} >
             <Popup title={'Workorder Priority'} showTitle={true} width={700} height={345}>
              <Position my={'center'} at={'center'} of={window} />
            </Popup>
        </Editing>
        <Scrolling mode="virtual" />
        <GroupPanel visible={true} />
        <FilterRow visible={true} />
        <FilterPanel visible ={true} />
  
        <ColumnChooser enabled={true} />
        {/* <StateStoring enabled={true} storageKey="this.props.sectionId" /> */}

        
        <Column dataField={'id'} visible={false}>
            <FormItem visible={false} />
        </Column>
        <Column dataField={'description'} >
            <RequiredRule message="Priority description is required." />
            <StringLengthRule max="200" message="The description text cannot exceed 200 characters."/>
        </Column>
        <Column dataField={'numericValue'} dataType="number">
            <RequiredRule message="Numeric value is required." />
            <FormItem editorOptions={{ showSpinButtons: true, min: 1 }} />
        </Column>
        <Column dataField={'active'} />
       
 
        </DataGrid>
        );
    }


}

const mapStateToProps = (state) => {
  return {
      user: state.oidc.user,
      grants: state.rights
  };
}


export default connect(mapStateToProps, null)(WOPriorityGrid)